import React, { useState, useEffect } from "react";
import { Carousel, Statistic } from "antd";
import List from "./list";
import AuthStatistic from "./Statistic";
import { ClockCircleOutlined } from "@ant-design/icons";

const contentStyle = {
  height: "300px",
  width: "100%",
};

const imgStyle = {
  height: "300px",
  width: "100%",
};

const Home = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timerID = setInterval(() => setTime(new Date()), 1000);

    return () => clearInterval(timerID);
  }, []);
  return (
    <div
      style={{
        height: "100%",
        overflow: "scroll",
      }}
    >
      <div>
        <Carousel arrows autoplay autoplaySpeed={2000} dots={true}>
          <div>
            <div style={contentStyle}>
              <img
                style={imgStyle}
                src="https://shopimg.jetour.com.cn/cms/Media/1610/p18.jpg"
              ></img>
            </div>
          </div>
          <div>
            <div style={contentStyle}>
              <img
                style={imgStyle}
                src="https://shopimg.jetour.com.cn/carNew/yinlong/zuocangbg0.png"
              ></img>
            </div>
          </div>
          <div>
            <div style={contentStyle}>
              <img
                style={imgStyle}
                src="https://shopimg.jetour.com.cn/carNew/yinlong/zuocangbg2.png"
              ></img>
            </div>
          </div>
          <div>
            <div style={contentStyle}>
              <img
                style={imgStyle}
                src="https://shopimg.jetour.com.cn/cms/20250521/1747808183172.png"
              ></img>
            </div>
          </div>
        </Carousel>
      </div>
      <div
        style={{
          marginTop: 20,
          background: "#F5F5F5",
          padding: 16,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h3>统计数据</h3>
          <div style={{ display: "flex", alignItems: "center" }}>
            截止时间
            <Statistic
              value={time.toLocaleTimeString()}
              prefix={<ClockCircleOutlined fontSize={18} />}
              style={{
                fontSize: 18,
                color: "#333",
                marginLeft: 8,
              }}
            />
          </div>
        </div>
        <AuthStatistic />
      </div>
      <div
        style={{
          border: "1px solid #E6E6E6",
          boxShadow: "0 2px 4px 0 rgba(0,0,0,0.06)",
          marginTop: 20,
          padding: 16,
        }}
      >
        <h3>热门互动</h3>
        <List />
      </div>
    </div>
  );
};

export default Home;
